import React from 'react';
import {convertOffers} from '../../services/offer.service';
import {OfferModel} from '../../models/offer.model';
import Offer, {OfferConfig} from './Offer';
import {expressInterestInOffer, handleApiResponse, logJsError} from '../../services/api.service';
import {
	getFromStore,
	saveToStore,
	StorePath,
	storeSaveAction,
	useStoreActionsFromStore,
} from '../../services/store.service';
import {logger} from '../../services/utils.service';
import MessageModel from '../../models/message.model';
import {addLatestMessage} from "../../services/message.service";
import Carousel from '../common/Carousel';
import {DealerInfo} from '../../models/dealership.model';

const Offers = ({data}: {data: any}) => {
	const storeAction = useStoreActionsFromStore(storeSaveAction);
	const offers: OfferModel[] = convertOffers(data);
	const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];
	const dealerInfo = getFromStore(StorePath.DEALER_INFO) as DealerInfo;
	const config: OfferConfig = {state: dealerInfo?.state};

	const handleOfferSelected = (offerId: any): void => {
		const offer = offers.find((offer) => offer.id === offerId) as OfferModel;
		if (offer) {
			const typingTimeout = setTimeout(() => {
				saveToStore(storeAction, StorePath.AGENT_TYPING, true);
			}, 1300);
			logger('Selected offer', offer);
			expressInterestInOffer(offer)
				.then(handleApiResponse)
				.then((data: any) => {
					addLatestMessage(data.messages, messages, storeAction);
					saveToStore(storeAction, StorePath.AGENT_TYPING, false);
					clearTimeout(typingTimeout);
				})
				.catch((error) => {
					logJsError(error);
				});
		}
	};

	return (
		<Carousel gap={offers.length > 1 ? 50 : 0} ariaLabel="Available offers">
			{offers.map((offer) => (
				<Offer key={offer.id} offer={offer} config={config} handleOfferSelected={handleOfferSelected}/>
			))}
		</Carousel>
	);
};

export default Offers;
